import { Button } from '@lune-fe/lune-ui-lib'
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight'
import Box from '@mui/material/Box'
import Image from 'next/image'

import TitleAndParagraph from '@/components/TitleAndParagraph'
import TwoColumnLayout, { ColumnWrapOrder } from '@/components/TwoColumnLayout'
import useDevice from '@/hooks/useDevice'

const LuneStory = () => {
    const { xsScreen } = useDevice()
    return (
        <Box
            sx={{
                ...(!xsScreen && {
                    '> .MuiGrid-root': {
                        alignItems: 'stretch',
                    },
                }),
            }}
        >
            <TwoColumnLayout
                leftCol={5}
                rightCol={6}
                columnWrapOrderOnMobile={ColumnWrapOrder.NORMAL}
            >
                <Box sx={{ display: 'flex', height: '100%' }}>
                    <Box
                        sx={{
                            width: '100%',
                            position: 'relative',
                            borderRadius: '48px',
                            overflow: 'hidden',
                            ...(xsScreen
                                ? {
                                      height: '0',
                                      paddingBottom: '100%',
                                      mb: 4,
                                  }
                                : {
                                      height: '100%',
                                  }),
                            img: {
                                position: 'absolute',
                                top: 0,
                                bottom: 0,
                                height: '100%',
                                ...(xsScreen
                                    ? {
                                          width: '100%',
                                          left: 0,
                                          right: 0,
                                      }
                                    : {
                                          width: 'auto',
                                      }),
                            },
                        }}
                    >
                        <Image
                            width={485}
                            height={486}
                            src={'/images/about/lune-story.png'}
                            alt={'Lune story'}
                        />
                    </Box>
                </Box>
                <Box>
                    <TitleAndParagraph
                        title={`Every company will be a climate company`}
                        paragraph={
                            <>
                                We are in an accelerating climate crisis.
                                <br />
                                <br />
                                It’s the biggest challenge humanity has ever faced. And we are not
                                acting fast enough. <br />
                                <br />
                                We set targets, we plan, we discuss, we negotiate, we hire
                                consultants to strategise, we tip-toe around in fear of greenwashing
                                allegations, we sit and wait for others to decide what we should do.{' '}
                                <br />
                                <br />
                                We must move faster. And we can! <br />
                                <br />
                                To scale as urgently as required, climate action cannot be seen as a
                                cost centre or a manual, laborious task. Instead, it must be the
                                default. <br />
                                <br />
                                And companies are waking up to this. Leading companies already view
                                climate action as a proven commercial driver. And they are making
                                climate action a seamless part of our day to day. <br />
                                <br />
                                Imagine if we could make greener decisions in real-time, at the
                                point when our activities generate emissions. Imagine if those
                                activities automatically funded climate projects around the world.{' '}
                                <br />
                                <br />
                                We founded Lune so that you can embed climate action into your
                                product. <br />
                                <br />
                                We founded Lune so that you can make your company a climate company.{' '}
                                <br />
                                <br />
                                We founded Lune to help you build a climate positive legacy.
                            </>
                        }
                    />
                    <Button
                        sx={{ mt: xsScreen ? 0 : 6 }}
                        variant={'contained'}
                        href={'https://lune.co/join-us'}
                        leftIcon={<ArrowCircleRightIcon />}
                    >
                        Join us
                    </Button>
                </Box>
            </TwoColumnLayout>
        </Box>
    )
}

export default LuneStory
